export default __webpack_public_path__ + "static/media/GF_Logo.6c657af5.jpg";